// src/ops/types/Outbox.ts
var OutboxService = /* @__PURE__ */ ((OutboxService2) => {
  OutboxService2["Main"] = "main";
  OutboxService2["Booking"] = "booking";
  OutboxService2["Payment"] = "payment";
  OutboxService2["Chat"] = "chat";
  OutboxService2["Ical"] = "ical";
  OutboxService2["Pricing"] = "pricing";
  return OutboxService2;
})(OutboxService || {});

export {
  OutboxService
};
